import { Component, inject, Input } from '@angular/core';
import { ButtonDirective } from 'primeng/button';
import { Topic } from '../../../models/topic';
import { GlobalsStore } from '../../../stores/globals.state';

@Component({
  selector: 'app-topic-button',
  standalone: true,
  imports: [ButtonDirective],
  templateUrl: './topic-button.component.html',
  styleUrl: './topic-button.component.scss',
})
export class TopicButtonComponent {
  readonly globalsStore = inject(GlobalsStore);
  @Input() topic!: Topic;

  public openTopic() {
    this.globalsStore.triggerAtlasEvent('loadTopic', {
      topic: this.topic,
    });
  }
}
